<template>
  <div class="w-100">
    <div class="cursor-default">
      <div class="d-flex align-center justify-space-between">
        <span
          v-for="(row, idx) in comment.comment.split('\n')"
          :key="idx"
          style="font-size: 13px">
          {{ row }} <br />
        </span>
        <b-action-menu
          v-if="!hideDelete"
          :actions="[
            {
              title: 'Видалити',
              action: () => $emit('delete', comment.id),
              icon: 'mdi-delete-forever',
              listItemProps: {
                class: 'text-error',
              },
              disabled: !isAuthor,
            },
          ]"
          icon="mdi-dots-horizontal"></b-action-menu>
      </div>
      <div
        class="d-flex align-center justify-space-between mt-3"
        style="color: #8e92bc; font-size: 12px">
        <div class="d-flex align-center w-100">
          <div v-if="!hidePhoto" class="mr-1">
            <BaseImage
              v-if="comment.user.photo"
              :src="comment.user.photo"
              rounded
              style="cursor: pointer"
              width="32"></BaseImage>
            <v-avatar v-else class="cursor-pointer" color="primary">
              <v-icon icon="mdi-account-circle"></v-icon>
            </v-avatar>
          </div>
          <span>{{ getPersonName(comment.user, { initials: true }) }}</span>
        </div>
        <span class="d-block w-50 text-end">
          {{ new CustomDate(comment.created_at).toString({ time: true }) }}
        </span>
      </div>
      <div class="d-flex justify-end mt-2">
        <slot name="showAllComments"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/plugins/index.js'
import { computed, inject } from 'vue'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { BActionMenu } from 'best-modules/components'

export default {
  components: {
    BActionMenu,
  },
  props: {
    comment: { type: Object, required: true },
    loading: { type: [Number, Boolean] },
    hideDelete: { type: Boolean },
    hidePhoto: { type: Boolean },
  },
  emits: ['delete'],
  methods: { CustomDate, getPersonName },
  setup(props) {
    const store = useStore()
    const loadingState = inject('loadingState', {})

    const userId = computed(() => store.state.user.userData?.id)
    const isAuthor = computed(() => {
      return props.comment.userId === userId.value
    })

    return { loadingState, isAuthor }
  },
}
</script>

<style lang="scss"></style>
